import React from 'react';
import { PageRow } from '@/components/layout/page-layout/general-layout/PageLayout';
import IconProvider from '@/components/ui/IconProvider';
import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';

import { usePlatformTranslation } from '@/hooks/usePlatformTranslation';
interface RowEditorProps {
  row: PageRow;
  rowIndex: number;
  onRemove: () => void;
  canRemove: boolean;
  onSettingsClick?: () => void;
  dragHandleProps?: {
    attributes: DraggableAttributes;
    listeners: SyntheticListenerMap;
  };
}

export default function RowEditor({ 
  row, 
  rowIndex, 
  onRemove, 
  canRemove, 
  onSettingsClick,
  dragHandleProps
}: RowEditorProps) {
  const { t } = usePlatformTranslation();
  return (
    <div className="absolute -top-4 left-0 right-0 flex justify-between items-center z-30">
      {/* Row Label with Settings Icon */}
      <div className="bg-brand-brand_purple text-white px-3 py-1 rounded-t-sm text-sm font-medium flex items-center gap-2">
        {/* Drag Handle */}
        {dragHandleProps && (
          <button
            {...dragHandleProps.attributes}
            {...dragHandleProps.listeners}
            className="text-white hover:text-blue-200 transition-colors cursor-grab active:cursor-grabbing"
            title={t('platform.layout.page-layout.drag_to_reorder')}
          >
            <IconProvider 
              iconstring="fa-grip-vertical" 
              size={14} 
              color="#ffffff"
            />
          </button>
        )}
        <span>Row {rowIndex + 1}</span>
        {onSettingsClick && (
          <button
            onClick={onSettingsClick}
            className="text-white hover:text-blue-200 transition-colors"
            title={t('platform.layout.page-layout.row_settings')}
          >
            <IconProvider 
              iconstring="fa-gear" 
              size={14} 
              color="#ffffff"
            />
          </button>
        )}
        {canRemove && (
          <button
            onClick={onRemove}
            className="text-white hover:text-blue-200 transition-colors"
            title={t('platform.layout.page-layout.remove_row')}
          >
            <IconProvider 
              iconstring="fa-trash" 
              size={14} 
              color="#ffffff"
            />
          </button>
        )}
      </div>
      
      {/* Row Controls */}
      <div className="flex gap-2">
        
      </div>
    </div>
  );
} 